import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import store from '../../../store';
import LocalStorage from '../../../components/DeviceStorage/LocalStorage';
import Utils from '../../../utils/Utils';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import EpgPersistence from '../../../AAF/Nepg/EpgPersistence';
import { Dates } from "packages/dates";
import AAF from "src/AAF/AAF";

class LevelUserTask extends AbstractRequestTask {
  constructor(uri, params = {}, node = "", user_status = '') {
    super();

    this.uri = uri;
    this.params = params;
    //this._node = node;
    //this._user_status = user_status;
    this.isAdsEnable = AAF.AdsUtils.isAdsEnable();
    this.version = 'v2' ;
    this.epg_version = LocalStorage.getItem('epgVersion') || false;
  }

  APAFilters(){
    return Utils.getApaMetadataKey('byr_filterlist_configuration', '{}','filterlist');
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    return getAppConfig().end_point_middleware + `${this.version}/` + this.uri;
  }

  getParams() {
    let params = super.getParams();
   
    const type = AAF.AdsUtils.getUserType();
    if (type) params.type = type;
  
    params.module_version = this.version;

    const APA =this.APAFilters();;
    if(APA){
      const filterList={}
      filterList['filterlist']=APA;
      params=Object.assign(filterList,params);
    }

    //Se agrega parametro adicional
    const user = store.getState().user;
    const lasttouch = user && user.lasttouch ? user.lasttouch.seen : false;
    // console.log('USERHASH ', user_hash);
    if (lasttouch) {
      params.lasttouch = lasttouch;
    }

    params['epg_version'] = this.epg_version;
    
    // SE ENVIA DATE CON OFSET PARA APIS QUE NECESITAN DEL TIEMPO ACTUAL
    const today = new Dates().unix(Utils.now(true).unix());
    const todayOffset = EpgPersistence.needsOffset() ? today.utcOffset(EpgPersistence.needsOffset(),false).format('YYYYMMDDHHmmss'): today.format('YYYYMMDDHHmmss');
    if(todayOffset){
      params.date_current_offset = todayOffset;
    }

    return Object.assign({}, params, this.params);
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default LevelUserTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/LevelUserTask.js